/* ELVETH — Banner lancio prodotti: autoplay, linguette, supporto editor tema. */
if (!customElements.get('fb-launch-banner')) {
  class FbLaunchBanner extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.fb-launch__slide'));
      this.tabs = Array.from(this.querySelectorAll('.fb-launch__tab'));
      this.delay = (parseInt(this.dataset.autoplay, 10) || 5) * 1000;
      this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
      this.paused = false;

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.go(i, true));
      });

      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.resume();
      });
      this.onVisibility = () => (document.hidden ? this.pause() : this.resume());
      document.addEventListener('visibilitychange', this.onVisibility);

      this.onBlockSelect = (e) => {
        const i = this.slides.findIndex((s) => s.contains(e.target) || e.target.contains(s));
        if (i > -1) {
          this.go(i, false);
          this.pause();
        }
      };
      this.onBlockDeselect = () => this.resume();
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.go(this.index, false);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    go(i, fromUser) {
      if (!this.slides.length) return;
      this.index = (i + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, k) => {
        const active = k === this.index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
        }
      });
      this.tabs.forEach((tab, k) => {
        const active = k === this.index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.dataset.activePosition = this.slides[this.index].dataset.position || '';

      if (fromUser) this.paused = false;
      this.restart();
    }

    restart() {
      clearTimeout(this.timer);
      this.classList.remove('is-playing');
      void this.offsetWidth;
      if (this.slides.length < 2 || this.paused) return;
      this.classList.add('is-playing');
      this.classList.remove('is-paused');
      this.timer = setTimeout(() => this.go(this.index + 1, false), this.delay);
    }

    pause() {
      this.paused = true;
      clearTimeout(this.timer);
      this.classList.add('is-paused');
    }

    resume() {
      if (!this.paused) return;
      this.paused = false;
      this.classList.remove('is-paused');
      this.restart();
    }
  }

  customElements.define('fb-launch-banner', FbLaunchBanner);
}
